import React, { useEffect } from 'react'
import { Helmet } from 'react-helmet'
import HerosectionHeader from '../../Componet/Herosection/HerosectionHeader'
import PricingL3He from '../../Componet/Pricing/PricingL3He'
import NewsletterL1 from '../../Componet/Newsletter/NewsletterL1'
import './PricingPage.css'

const howItWorksStepsHe = [
  {
    number: '1',
    title: 'צור את הפרויקט שלך',
    description: 'מתחילים מיד'
  },
  {
    number: '2',
    title: 'בחר את המסלול שלך',
    description: 'גישה לייעוץ מומחה או מעבר מהיר להערכה החכמה שלנו'
  },
  {
    number: '3',
    title: 'קבע פגישה',
    description: 'מיישרים ציפיות, מטרות ודרישות יחד'
  },
  {
    number: '4',
    title: 'עקוב אחר ההתקדמות',
    description: 'רואים כל שלב ישירות מהדשבורד שלך'
  },
  {
    number: '5',
    title: 'הפרויקט הושלם',
    description: 'מקבלים קוד מקור או פרטי גישה בלי כאב ראש'
  }
]

function PricingHe() {
  useEffect(() => {
    // Add structured data for SEO
    const structuredData = {
      "@context": "https://schema.org",
      "@type": "Product",
      "name": "DevSecOps ONE",
      "description": "מנוי חודשי למהנדס DevSecOps לפי דרישה עם בקשות ללא הגבלה וזמן תגובה של 48-72 שעות",
      "brand": {
        "@type": "Brand",
        "name": "Epicfinal"
      },
      "offers": {
        "@type": "Offer",
        "price": "5400",
        "priceCurrency": "USD",
        "billingDuration": "P1M",
        "availability": "https://schema.org/InStock"
      }
    };

    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.textContent = JSON.stringify(structuredData);
    document.head.appendChild(script);

    return () => {
      document.head.removeChild(script);
    };
  }, []);

  return (
    <>
      <Helmet>
        <title>DevSecOps ONE תעריפים - $4,829/חודש | Epicfinal</title>
        <meta name="description" content="קבלו בקשות DevSecOps ללא הגבלה ב-$4,829 לחודש. זמן תגובה של 48-72 שעות, השהיה או ביטול בכל עת. מהנדס לפי דרישה לתכנון, פיתוח, תפעול, אינטגרציות, אבטחה וייעוץ." />
        <meta name="keywords" content="תעריפי DevSecOps, מהנדס לפי דרישה, מנוי חודשי, בקשות ללא הגבלה, הנדסת ענן, ייעוץ אבטחה, שירותי DevOps" />
        <meta name="robots" content="index, follow" />
        <meta property="og:title" content="DevSecOps ONE תעריפים - $4,829/חודש | Epicfinal" />
        <meta property="og:description" content="קבלו בקשות DevSecOps ללא הגבלה ב-$4,829 לחודש. זמן תגובה של 48-72 שעות, השהיה או ביטול בכל עת." />
        <meta property="og:type" content="product" />
        <meta property="og:url" content="https://epicfinal.com/pricing-he" />
        <meta property="og:image" content="https://epicfinal.com/images/pricing-og-he.jpg" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="DevSecOps ONE תעריפים - $4,829/חודש" />
        <meta name="twitter:description" content="קבלו בקשות DevSecOps ללא הגבלה ב-$4,829 לחודש. זמן תגובה של 48-72 שעות." />
        <link rel="canonical" href="https://epicfinal.com/pricing-he" />
      </Helmet>
      <div>
        <HerosectionHeader folder1={""} folder2={"-"} name={"מנוי חודשי"} />
        <div className="page-content">
          <PricingL3He />
          <section className="pricing-bottom-section" dir="rtl">
            <div className="container">
              <div className="pricing-bottom-shell">
                <div className="pricing-bottom-intro">
                  <p className="pricing-bottom-kicker">מוכנים להצטרף?</p>
                  <h2>קבלו גישה מלאה לפלטפורמה</h2>
                  <a
                    className="pricing-bottom-cta"
                    href="https://boarding.eu.epicfinal-cloud.com/login?lang=he"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    DevSecOps ONE
                  </a>
                </div>

                <div className="pricing-how-it-works">
                  <div className="pricing-how-it-works-header">
                    <h3>איך זה עובד</h3>
                  </div>

                  <div className="pricing-how-it-works-grid">
                    {howItWorksStepsHe.map((step) => (
                      <article className="pricing-how-it-works-card" key={step.number}>
                        <span className="pricing-how-it-works-number">{step.number}</span>
                        <h4>{step.title}</h4>
                        <p>{step.description}</p>
                      </article>
                    ))}
                  </div>

                  <div className="pricing-bottom-summary">
                    <h3>פלטפורמה אחת. שליטה מלאה.</h3>
                    <p>בלי כאב ראש.</p>
                  </div>
                </div>

                <div className="pricing-bottom-video-wrap">
                  <div className="pricing-bottom-video">
                    <iframe
                      src="https://www.youtube.com/embed/AsEa4XD4ZSA?si=y3wapsIHOB874gmc"
                      title="DevSecOps ONE Demo"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                      allowFullScreen
                    ></iframe>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <NewsletterL1 />
        </div>
      </div>
    </>
  )
}

export default PricingHe

